import { render } from "./LoginLayout.vue?vue&type=template&id=9bb0e4e6&scoped=true"
import script from "./LoginLayout.vue?vue&type=script&lang=js"
export * from "./LoginLayout.vue?vue&type=script&lang=js"

import "./LoginLayout.vue?vue&type=style&index=0&id=9bb0e4e6&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-9bb0e4e6"

export default script